export default (config: any) => {
  const token = localStorage.getItem('token')
  if (token)
    config.headers.Authorization = "Bearer " + token;
  return config;
};
